/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import {
  Comment,
  CommentListParams,
  Pagination,
  CommentCreationParams
} from '~core/models/core.models';
import { ApiConstantsService } from './api-constants.service';

@Injectable()
export class CommentService {
  protected _httpClient = inject(HttpClient);
  protected _apiConstantsService = inject(ApiConstantsService);

  read(commentId: string): Observable<Comment> {
    return this._httpClient.get<Comment>(
      `${this._apiConstantsService.commentUrl}/${commentId}`
    );
  }

  list(params?: CommentListParams): Observable<Pagination<Comment>> {
    return this._httpClient.get<Pagination<Comment>>(
      this._apiConstantsService.commentUrl,
      {
        params: {
          ...params,
          sort: params?.sort || 'createdAt',
          desc: params?.desc || 'createdAt'
        } as Record<string, any>
      }
    );
  }

  create(data: CommentCreationParams): Observable<Comment> {
    return this._httpClient.post<Comment>(
      this._apiConstantsService.commentUrl,
      data
    );
  }

  update(commentId: string, data: Partial<Comment>): Observable<Comment> {
    return this._httpClient.patch<Comment>(
      `${this._apiConstantsService.commentUrl}/${commentId}`,
      data
    );
  }

  delete(commentId: string): Observable<unknown> {
    return this._httpClient.delete(
      `${this._apiConstantsService.commentUrl}/${commentId}`
    );
  }
}
